/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "components/layout/DashboardLayout";
import DashboardNavbar from "components/navigation/DashboardNavbar";

// Pricing page components
import Header from "./components/Header";
import Footer from "./components/Footer";
import PricingCards from "./components/PricingCards";
import EstimateBill from "./components/EstimateBill";
import Faq from "./components/Faq";

function PricingPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <br />
      <br />
      <br />
      <Header>
        <Container>
          <PricingCards />
          <EstimateBill />
          <Faq />
        </Container>
      </Header>
    </DashboardLayout>
  );
}

export default PricingPage;
